/**
 * Monte Carlo Stats Mock
 *
 * Summary statistics card showing the key metrics from a
 * Monte Carlo simulation — expected return, VaR, probability
 * of profit, drawdown stats, and confidence interval.
 */

const stats = [
  { label: 'Expected Return', value: '+15.2%', sub: '(mean)', color: '#22c55e' },
  { label: 'Std Deviation', value: '12.3%', sub: '', color: '#e5e7eb' },
  { label: 'Value at Risk (95%)', value: '-8.5%', sub: '5th percentile', color: '#ef4444' },
  { label: 'Probability of Profit', value: '87.3%', sub: '873 / 1,000 sims', color: '#22c55e' },
  { label: 'Avg Max Drawdown', value: '-22.4%', sub: 'mean of max DDs', color: '#f59e0b' },
  { label: 'Worst Drawdown (P95)', value: '-42.0%', sub: '95th percentile', color: '#ef4444' },
];

const confidenceInterval = { lower: '+2.1%', upper: '+28.3%', level: '95%' };

export default function MonteCarloStatsMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header">
        <span className="dot" /> Monte Carlo Statistics &mdash; 1,000 Simulations
      </div>
      <div className="platform-mock-body" style={{ padding: '0.75rem' }}>
        {/* Stats grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '0.5rem',
        }}>
          {stats.map((s) => (
            <div key={s.label} style={{
              background: '#1e293b',
              borderRadius: 4,
              padding: '0.4rem 0.5rem',
              border: '1px solid #334155',
            }}>
              <div style={{ fontSize: '0.5rem', color: '#64748b', marginBottom: '0.15rem' }}>
                {s.label}
              </div>
              <div style={{ fontSize: '0.875rem', fontWeight: 700, color: s.color, fontFamily: 'ui-monospace, monospace' }}>
                {s.value}
              </div>
              {s.sub && (
                <div style={{ fontSize: '0.4375rem', color: '#475569', marginTop: '0.1rem' }}>
                  {s.sub}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Confidence interval bar */}
        <div style={{
          marginTop: '0.625rem',
          background: '#1e293b',
          borderRadius: 4,
          padding: '0.4rem 0.5rem',
          border: '1px solid #334155',
        }}>
          <div style={{ fontSize: '0.5rem', color: '#64748b', marginBottom: '0.3rem' }}>
            {confidenceInterval.level} Confidence Interval
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <span style={{ fontSize: '0.6875rem', fontWeight: 600, color: '#94a3b8', fontFamily: 'ui-monospace, monospace' }}>
              {confidenceInterval.lower}
            </span>
            <div style={{ flex: 1, height: 6, background: '#0f172a', borderRadius: 3, position: 'relative', overflow: 'hidden' }}>
              <div style={{
                position: 'absolute',
                left: '8%',
                right: '8%',
                top: 0,
                bottom: 0,
                background: 'linear-gradient(90deg, #3b82f633, #22c55e33)',
                borderRadius: 3,
              }} />
            </div>
            <span style={{ fontSize: '0.6875rem', fontWeight: 600, color: '#22c55e', fontFamily: 'ui-monospace, monospace' }}>
              {confidenceInterval.upper}
            </span>
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">
        87% of simulations were profitable. The 95% confidence interval spans +2.1% to +28.3%.
      </div>
    </div>
  );
}
